import axios from 'axios'

import { env } from '@/config/env'

export interface HealthStatus {
  status: string
  app: string
  env: string
}

export interface ReadinessStatus {
  status: string
  checks: Record<string, string>
}

/** El healthcheck vive en la raíz del backend, fuera del prefijo /api/v1. */
const rootClient = axios.create({ baseURL: env.apiBaseUrl, timeout: 8_000 })

export const systemApi = {
  async health(): Promise<HealthStatus> {
    const { data } = await rootClient.get<HealthStatus>('/health')
    return data
  },
  async readiness(): Promise<ReadinessStatus> {
    const { data } = await rootClient.get<ReadinessStatus>('/health/ready')
    return data
  },
}
